import React from 'react';
import {
  FormControl, InputLabel, Select, MenuItem, useTheme,
  SelectChangeEvent,
} from '@mui/material';

type BasicSelectProps = {
  onChange: (e: SelectChangeEvent<string>) => void,
  value: string,
  options: any[],
  optKey: string,
  selectId: string,
  disabled: boolean,
  label?: string,
  width?: number| string
}

export default function BasicSelect(props:BasicSelectProps) {
  const {
    onChange, value, options, optKey, label, selectId, disabled, width,
  } = props;
  const theme = useTheme();
  return (
    <FormControl variant="outlined" style={{ width, margin: 'auto' }}>
      <InputLabel color="secondary" id="demo-simple-select-outlined-label">
        <span style={{ color: theme.palette.secondary.main }}>
          {label}
        </span>

      </InputLabel>
      <Select
        id={selectId}
        value={value}
        onChange={onChange}
        label={label}
        disabled={disabled}
      >
        {options && options.map((opt, item) => (
          <MenuItem key={+item} value={opt.id} style={{ width: '100%', minHeight: '48px' }}>
            {opt[optKey]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

BasicSelect.defaultProps = { label: '', width: 300 };
